import {
  createTableColumn,
  Link,
  Tooltip,
  Text,
} from "@fluentui/react-components";
import useWindowSize from "../../helpers/useWindowSize";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";
import { useState } from "react";
import i18n from "i18next";

function ToolSelectionColumns(preiseSichtbar: boolean) {
  const windowSize = useWindowSize();
  const [clickedArtikel, setClickedArtikel] = useState<
    ILSP3ResponseDto | undefined
  >(undefined);
  const columns = [
    // ------------Artikel------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "artikelId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            content={i18n.t<string>("artikelIdTooltip")}
            relationship="label"
          >
            <Text> {i18n.t<string>("artikelId")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        if (windowSize.width > 500) {
          if (item.hasSachwerte) {
            return (
              <Tooltip
                content={i18n.t<string>("displayTechnicalData")}
                relationship="label"
              >
                <Link
                  onClick={(event: any) => {
                    setClickedArtikel(item);
                  }}
                >
                  {" "}
                  {item.artikelId}
                </Link>
              </Tooltip>
            );
          } else {
            return <Text>{item.artikelId}</Text>;
          }
        } else {
          <>
            <Text>{item.artikelId}</Text>
            <Text>
              {item.artikel ? item.artikel.benennungDE : item.benennungDE}
            </Text>
          </>;
        }
      },
    }),
    // ------------ BENNENUNG -------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "benennungM1",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("benennung")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {i18n.language.includes("de")
              ? item.artikel.benennungDE
              : item.artikel.benennungEN}
          </Text>
        );
      },
    }),
    // --------- Hersteller -----------
    createTableColumn<any>({
      columnId: "herstellerId",
      renderHeaderCell: () => {
        return <Text>{i18n.t<string>("hersteller")}</Text>;
      },
      renderCell: (item) => {
        return <Text>{item.toolhersteller}</Text>;
      },
    }),
    // --------- min Drehmoment -----------
    createTableColumn<any>({
      columnId: "minDrehmomentId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            content={i18n.t<string>("minDrehmomentCol")}
            relationship={"label"}
          >
            <Text>min Nm</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.minDrehmoment ? item.minDrehmoment?.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------ max Drehmoment -----------
    createTableColumn<any>({
      columnId: "maxDrehmomentId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            content={i18n.t<string>("maxDrehmomentCol")}
            relationship={"label"}
          >
            <Text>max Nm</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.maxDrehmoment ? item.maxDrehmoment?.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------ Gewicht -----------
    createTableColumn<any>({
      columnId: "gewichtId",
      renderHeaderCell: () => {
        return <Text>{i18n.t<string>("gewichtKg")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>{item.gewicht ? item.gewicht?.toLocaleString() : "-"}</Text>
        );
      },
    }),
    // ------------ Laenge -----------
    createTableColumn<any>({
      columnId: "laengeId",
      renderHeaderCell: () => {
        return <Text>{i18n.t<string>("gesamtlaenge")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.gesamtlaenge ? item.gesamtlaenge?.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
  ];
  if (preiseSichtbar) {
    columns.push(
      // ------------preis------------
      createTableColumn<ILSP3ResponseDto>({
        columnId: "preis",
        renderHeaderCell: () => {
          return (
            <Tooltip
              relationship="label"
              content={<div>{i18n.t<string>("preisTooltip")}</div>}
            >
              <Text>
                {i18n.t<string>("preis")}
                <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
              </Text>
            </Tooltip>
          );
        },
        renderCell: (item) => {
          if (item.hasOwnProperty("artikel") && item.artikel) {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.artikel?.netto
                    ? item.artikel?.netto.toLocaleString(
                        i18n.language.includes("de") ? "de-DE" : "en-EN",
                        { minimumFractionDigits: 2 },
                      ) + " €"
                    : ""}
                </Text>
              </div>
            );
          } else {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.netto
                    ? item.netto.toFixed(2).toLocaleString() + " €"
                    : ""}
                </Text>
              </div>
            );
          }
        },
      }),
    );
  }
  return {
    columns: columns,
    clickedArtikel: clickedArtikel,
  };
}
export default ToolSelectionColumns;
